exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".menu-top,.menu-game{padding:.25rem 0}.menu-top > div,.menu-game > div{height:2.5rem}.menu-top p,.menu-game p{margin:0}.card-bg-icon{overflow:hidden;position:relative}.card-bg-icon > svg{font-size:10em;position:absolute;top:-2rem;right:0;opacity:15%}.online-status-icon{font-size:.6rem;margin-right:.4em;vertical-align:middle}", ""]);

